import React from 'react'
import { useAuthStore } from '../lib/zustand'
import { Navigate } from 'react-router-dom'

export interface PrivateRoutePropsInterface {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any
  path?: string
}

const PrivateRoute: React.FC<PrivateRoutePropsInterface> = ({ component: RouteComponent }) => {
  const { isLogin } = useAuthStore()
  return !isLogin ? <Navigate to="/login" replace /> : <RouteComponent />
}

export default PrivateRoute
